import React from 'react';
import { NamedLink, StrapiContentRenderer } from '../../../components';
import IconArrowTop from '../../../components/IconArrowTop/IconArrowTop';
import { getImagesLink } from '../../../util/dataExtractors';
import moment from 'moment';
import { isArrayLength } from '../../../util/genericHelpers';

import css from '../BlogPage.module.css';
import { draftSlug } from '../../../routing/routeConfiguration';

const baseUrl = process.env.REACT_APP_STRAPI_BASE_URL;

function BlogCard(props) {
  const { blog } = props;

  const blogImages = blog?.coverImage?.url;
  const tag = blog?.tag?.data?.attributes?.name;
  const title = blog?.title;
  const createdAt = blog?.createdAt;
  const description = blog?.description;
  const slug = blog?.slug;
  const imagesLink = getImagesLink([blogImages], baseUrl);

  return (
    <NamedLink className={css.blog} name="SingleBlogPage" params={{ title: slug || draftSlug }}>
      <div className={css.blogImg}>
        {isArrayLength(imagesLink) && <img src={imagesLink[0]} alt={title} />}
      </div>
      <div className={css.blogDetails}>
        <div className={css.blogPostTime}>
          <div className={css.tagContainer}>
            <span className={css.blogTime}>{tag}</span>
          </div>
          <span className={css.blogTime}>{moment(createdAt).format('DD/MM/YYYY')}</span>
        </div>
        <div className={css.cardTitleSec}>
          <h2 className={css.blogPostTitle}>{title}</h2>
          <IconArrowTop />
        </div>
        {/* <p className={css.blogPostDescription}>
          {description ? <StrapiContentRenderer content={description} /> : null}
        </p> */}
      </div>
    </NamedLink>
  );
}

export default BlogCard;
